import {
  ENTERPRISE_PLAN_CODE,
  HIGH_VOLUME_PLAN_CODE,
  PLATINUM_PLAN_CODE,
  GOLD_PLAN_CODE,
  SILVER_PLAN_CODE,
  BRONZE_PLAN_CODE,
  STARTER_PLAN_CODE,
} from '../../../../../constants/plan-codes';

export const SIMPLIFIED_PLANS = {
  highvolume: 'highvolume',
  scale: 'scale',
  growth: 'growth',
  starter: 'starter',
};

export const getSimplifiedPlanCode = (planCode) => {
  const token = planCode.split('_')[0];
  switch (token) {
    case HIGH_VOLUME_PLAN_CODE:
      return SIMPLIFIED_PLANS.highvolume;
    case ENTERPRISE_PLAN_CODE:
      return SIMPLIFIED_PLANS.scale;
    case PLATINUM_PLAN_CODE:
      return SIMPLIFIED_PLANS.scale;
    case GOLD_PLAN_CODE:
      return SIMPLIFIED_PLANS.scale;
    case SILVER_PLAN_CODE:
      return SIMPLIFIED_PLANS.growth;
    case BRONZE_PLAN_CODE:
      return SIMPLIFIED_PLANS.growth;
    case STARTER_PLAN_CODE:
      return SIMPLIFIED_PLANS.starter;
    default:
      return planCode;
  }
};

export const simplifyPlans = (plans) => {
  const simplifiedPlanMap = plans.reduce((acc, plan) => {
    const simplifiedPlanCode = getSimplifiedPlanCode(plan.code);
    const planObj = { ...plan, simplifiedPlanCode };
    if (!acc[simplifiedPlanCode]) {
      return {
        ...acc,
        [simplifiedPlanCode]: [planObj],
      };
    }
    acc[simplifiedPlanCode].push(planObj);
    return acc;
  }, {});

  const order = [SIMPLIFIED_PLANS.starter, SIMPLIFIED_PLANS.growth, SIMPLIFIED_PLANS.scale, SIMPLIFIED_PLANS.highvolume];
  const ordered = order.map((planName) => simplifiedPlanMap[planName] || []);
  return ordered;
};
